export const ERROR_MESSAGES = {
  required: "This field is required",
  pattern: "The pattern entered is not allowed",
  min: (min, actual) => `${actual} is below the minimum allowed (${min})`,
  max: (max, actual) => `${actual} exceeds the maximum allowed (${max})`
};
